import axios from 'axios';
import config from '../../config/config';


const isValidExtension = (fileData,{validMimeType=[],validExtensions=[]}) => {
	const ext = getFileExtension(fileData);
	return validMimeType.includes(fileData.type) || validExtensions.includes("."+ext);
};

const getFileExtension = fileData => fileData.name.split('.').pop();

const getFileName = fileData => fileData.name

export const getImagePath = function(url, dim, type) {
	if (!url || url.indexOf('http') == 0 || url.indexOf('base64') != -1) {
		return url;
	}
	let imageDomain = '';
	const imageDomainArray = config.staticImageDomains;
	const productImageBasePath =
		config.IMAGE_COMPRESSION + config.PRODUCT_IMAGE_BASE_PATH;
	imageDomain = imageDomainArray[0];
	let finalImagePath = "";
	finalImagePath = imageDomain + productImageBasePath + url;
	return finalImagePath;
};

const uploadImageRequest = (formData, cb,supplierId, isJdVendor,fileSize) => {
	let url = '/vendorapis/products/product/uploadb2bClientFile';
	formData.append('supplier_id', supplierId);
	axios({
		url,
		method: 'POST',
		data: formData, // Data sent to server, a set of key/value pairs (i.e. form fields and values)
		cache: false,
		headers: { 'Content-Type': 'multipart/form-data' }
	}).then(({ data }) => {
		let isError = data?.isError || false;
		cb({
			...data,
			fileSize,
			uploaded: (isError ? false : true)
		});
	}).catch(err => {
		console.log(err);
	});
}

const uploadFile = ({ isJdVendor = false, fileData, cb,supplierId,initiateCb=true }) => {
	initiateCb && cb({
		uploading:true,
		uploaded:false
	})
	var formData = new FormData();
	formData.append('file', fileData);
	uploadImageRequest(formData, cb,supplierId, isJdVendor,fileData.size);
};


export const uploadMultipleFile = ({
	isJdVendor = false,
	maxFileSize,
	data,
	fileLimit,
	validMimeType,
	validExtensions,
	cb,
	supplierId
}) => {
	if (!data.length) {
		return;
	}
	let finalDataArr = [];
	let fileCount = 0;
	for(let key = 0;key < data.length;key++){
		const fileData = data[key];
		if (typeof fileData === 'object') {
			fileData.fileKey = +new Date() + key;
			if (isValidExtension(fileData,{validMimeType,validExtensions})) {
				if(fileData.size > maxFileSize){
					cb({
						isSuccess : false,
						isFileSizeError : true,
						fileKey:fileData.fileKey,
						ext : getFileExtension(fileData),
						fileName : getFileName(fileData)
					})
					continue;
				}else if(fileLimit != undefined && fileLimit != null && fileCount >= fileLimit){
					cb({
						isSuccess : false,
						isFileLimitError : true,
						fileKey:fileData.fileKey,
						ext : getFileExtension(fileData),
						fileName : getFileName(fileData)
					})
					continue;
				}
				cb({
					uploading:true,
					uploaded:false,
					fileKey:fileData.fileKey,
					ext : getFileExtension(fileData),
					fileName : getFileName(fileData),
					fileSize: fileData.size
				})
				fileCount++;
				finalDataArr.push(fileData);
			} else{
				cb({
					isSuccess :false,
					isValidExtension:false,
					fileKey:fileData.fileKey,
					ext : getFileExtension(fileData),
					fileName : getFileName(fileData),
					fileSize: fileData.size
				})
			}
		}
	}

	finalDataArr.map((fileData, key) => {
		uploadFile({
			isJdVendor,
			fileData,
			ext : getFileExtension(fileData),
			supplierId,
			initiateCb:false,
			cb: payload => {
				cb({
					isSuccess:true,
					...payload,
					fileKey:fileData.fileKey,
					ext : getFileExtension(fileData),
					fileName : getFileName(fileData),
					noOfFilesToUpload: finalDataArr.length
				});
			}
		});
	});
};
